import { render, staticRenderFns } from "./tile.vue?vue&type=template&id=67f49144&"
import script from "./tile.vue?vue&type=script&lang=ts&"
export * from "./tile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports